import { render } from "./changePwd.vue?vue&type=template&id=2e62fbf0&scoped=true&ts=true"
import script from "./changePwd.vue?vue&type=script&lang=ts"
export * from "./changePwd.vue?vue&type=script&lang=ts"

import "./changePwd.vue?vue&type=style&index=0&id=2e62fbf0&lang=scss&scoped=true"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/lpoa_prod_deploy/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e62fbf0"]])

export default __exports__